module.exports = "<div>\r\n  <moh-select labelText=\"קירבה\" [formControl]=\"baseAbstractControl\" [options]=\"closenessList\" [displayField]=\"'Text'\" [MarkAsRequired]=\"MarkAsRequired\"></moh-select>\r\n  <moh-error-message *ngIf=\"baseAbstractControl.touched\" [control]=\"baseAbstractControl\"></moh-error-message>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/components/general/gzz-closeness/gzz-closeness.component.html
// module id = ../../../../../src/app/components/general/gzz-closeness/gzz-closeness.component.html
// module chunks = main